<template>
  <div class="classContainer">
    <van-nav-bar
      title="考勤打卡"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="clocking">
      <div class="classScheduleCon">
        <p class="classTitle">
          {{ detailObj.planName }}
          <img class="classImg" src="@/assets/images/daka-3.png">
        </p>
        <p class="classTitleDsc">课程时间：{{ detailObj.teachingStartTime }}-{{ detailObj.teachingEndTime }}</p>
        <p class="classTitleDsc">授课老师：{{detailObj.teacherName}}</p>
      </div>
      <div class="clockingCon">
        <div v-if="isClock">
          <p class="clockingTitle">
            <span class="line"></span>
            <span class="clock">{{ title }}</span>
          </p>
          <p class="clockingTime" @click="signIn">
            <span class="sign">{{ title }}<br/><i class="time">{{ currentTime }}</i></span>
          </p>
        </div>
        <div class="stepCon" v-else>
          <van-steps direction="vertical" :active="clockList.length" active-color="#3776FF">
            <van-step v-for="item in clockList">
              <h3>签到打卡</h3>
              <p class="signTime">打卡时间：{{ item.clockTime }}
              <span class="updateTime" @click="isClock = true;title='更新打卡'">更新打卡时间</span>
              </p>
            </van-step>
          </van-steps>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { teachingPlanClock,userClockInfo } from '@/api/classSchedule'
export default {
  name: "clocking",
  data() {
    return {
      title:'签到打卡',
      timer:null,
      locationTimer:null,
      currentTime:'',
      isClock:true,
      planDetailId:'',
      clockList:[],
      detailObj:{}

    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1)
    },
    updateCurrentTime(){
      const now = new Date();
      this.currentTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
    },
    // 签到打卡
    async signIn(){
      try{
        let res = await teachingPlanClock({planDetailId:this.planDetailId});
        if(res){
          this.isClock = false;
          this.queryUserClockInfo();
        }
      }catch (error){
      }

    },
    //查询签到信息
    async queryUserClockInfo(){
      try{
        let res = await userClockInfo({planDetailId:this.planDetailId});
        this.detailObj = res.data;
        this.clockList = res.data.clockList;
        if(res.data.clockList && res.data.clockList.length > 0){
          this.isClock = false;
        }else {
          this.isClock = true;
        }
      }catch (error){
        this.isClock = true;
      }
    }

  },
  mounted() {
    this.planDetailId = this.$route.query.planDetailId;
    this.queryUserClockInfo();
    this.timer = setInterval(this.updateCurrentTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
.classContainer {
  .clocking {
    height: calc(100vh - 46px);
    background: #f5f5f5;
    padding: 12px 16px;
    overflow-y: auto;
    display: flex;
    flex-flow: column;
    p{
      font-size: 16px;
      margin-bottom: 5px;
    }
    .classScheduleCon{
      padding: 19px 13px 15px 16px;
      background: #FFFFFF;
      border-radius: 12px;
      .classTitle{
        color: #2F2F46;
        .classImg{
          width: 48px;
          height: 48px;
          float: right;
        }
      }
      .classTitleDsc{
        font-size: 14px;
        color: #7A7C8B;
      }
    }
    .clockingCon{
      flex:1;
      margin-top: 20px;
      padding: 19px 13px 15px 16px;
      background: #FFFFFF;
      border-radius: 12px;
      .clockingTitle{
        font-size: 14px;
        .line{
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          background: #3776FF;
          margin-right: 10px;
        }
      }
      .clockingTime{
        width: 136px;
        height: 136px;
        background: #3776FF;
        border-radius: 50%;
        text-align: center;
        margin: 50px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .sign{
          color: #FFFFFF;
          font-size: 20px;
         }
        .time {
          color: #FFFFFF;
          font-size: 15px;
          font-style: normal;
        }
      }
      .stepCon{
        ::v-deep .van-step__circle{
          width: 10px;
          height: 10px;
        }
        ::v-deep .van-steps--vertical{
          padding-left: 20px;
        }
        h3{
          font-size: 16px;
          color: #3776FF;
        }
        .signTime{
          font-size: 14px;
          margin-top: 5px;
          .updateTime{
            margin-left: 10px;
            color: #3776FF;
          }
        }
      }
    }
  }
}
</style>
